<template>
  <div class="installment-item" @click="handleClick">
    <span class="installment-item-text">
      {{ installmentTerm }}
      <span class="installment-item-label">
        {{ installment.notificationLabel }}
      </span>
    </span>
    <span>{{ $n(installment.amount, 'currency', locale.value) }}</span>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";
import {useI18n} from "vue-i18n";

export default defineComponent({
  name: "InstallmentItem",
  props: {
    installment: {
      type: Object,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true
    }
  },
  emits: ["select-installment-item"],
  setup(props, {emit}) {
    const { t, n, locale } = useI18n();
    const handleClick = () => {
      emit("select-installment-item", props.installment);
    };
    const installmentTerm = computed((): string | undefined => {
      switch(props.installment.term) {
        case 'week':
          return t("week");
        case 'week2':
          return t("week2");
        case 'week3':
          return t("week3");
        case 'month':
          return t("month");
        case 'remainingBalance':
          return t("remainingBalance");
        default:
          return '';
      }
    })
    return {
      handleClick,
      installmentTerm,
      n,
      locale
    };

  }

});
</script>

<style scoped>
.installment-item {
  display: flex;
  padding: 16px;
  margin-top: 15px;
  align-items: baseline;
  border-radius: 10px;
  border: 1px solid var(--Gray-elements-Border-1-inactive-botton);
  background: var(--main-white);
}

.installment-item:hover {
  background-color: #f0f0f0;
}

.installment-item-text {
  flex: 1 0 0;
  text-align: left;
  color: var(#111);
  font-feature-settings: "clig" off, "liga" off;
  /* Text regular-content-Page title */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 185.714% */
}

.installment-item-label {
  color: var(#666);
  font-feature-settings: "clig" off, "liga" off;

  /* Text regular-content-Page title */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}
</style>
